import { Box, Typography, Alert, TextField, CircularProgress, Stack, MenuItem } from "@mui/material";
import { useForm } from "react-hook-form";
import ConfirmDialog from "@components/molecules/ConfirmDialog/ConfirmDialog";
import InputText from "@components/atoms/InputText/InputText";
import { IDispatchDialog } from "src/types/molecules";
const DispatchDialog = ({
  open,
  productName,
  quantity,
  dispatchedQuantity,
  amount,
  setAmount,
  employeeCode,
  setEmployeeCode,
  warehouses,
  warehousesStatus,
  warehouseId,
  setWarehouseId,
  onConfirm,
  onCancel,
  isLoading = false,
  errorMessage
}: IDispatchDialog) => {
  const {
    register
  } = useForm();
  const remaining = quantity - dispatchedQuantity;
  const amountValue = Number(amount);
  const isValidAmount = amount.trim() !== "" && !Number.isNaN(amountValue) && amountValue > 0 && amountValue <= remaining;
  const disabled = !isValidAmount || !employeeCode.trim() || !warehouseId || isLoading || warehousesStatus !== "ready";

  // ADR-6: ConfirmDialog fires confirmAction on Enter without checking `disabled`,
  // so this handler re-validates internally before delegating to the caller.
  const handleConfirm = () => {
    if (disabled) return;
    onConfirm();
  };
  const isUnavailable = warehousesStatus === "empty";
  const bodyContent = () => {
    if (warehousesStatus === "loading") {
      return <Box marginTop={1}>
          <Stack direction="row" spacing={1} alignItems="center">
            <CircularProgress size={20} />
            <Typography>Cargando bodegas…</Typography>
          </Stack>
        </Box>;
    }
    if (warehousesStatus === "error") {
      return <Box marginTop={1}>
          <Alert severity="error">
            No se pudieron cargar las bodegas. Cierra e intenta de nuevo.
          </Alert>
        </Box>;
    }
    if (warehousesStatus === "empty") {
      return <Box marginTop={1}>
          <Alert severity="warning">
            No hay bodegas registradas. Un administrador debe crear al menos
            una bodega para poder despachar.
          </Alert>
        </Box>;
    }
    return <Box marginTop={1}>
        <Typography>{`Despachado: ${dispatchedQuantity} / ${quantity}`}</Typography>
        <Typography sx={{
        mb: 2
      }}>{`Restante: ${remaining}`}</Typography>
        <TextField id="dispatchAmount" label="Cantidad a despachar" type="number" placeholder="Ingresa la cantidad *" inputProps={{
        min: 0,
        max: remaining,
        step: "any"
      }} value={amount} onChange={e => setAmount(e.target.value)} disabled={isLoading} autoFocus fullWidth sx={{
        mb: 2
      }} />
        <TextField select id="dispatchWarehouse" label="Bodega" placeholder="Selecciona una bodega *" value={warehouseId} onChange={e => setWarehouseId(e.target.value)} disabled={isLoading} fullWidth sx={{
        mb: 2
      }}>
          {warehouses.map(warehouse => <MenuItem key={warehouse.id} value={String(warehouse.id)}>
              {warehouse.name}
            </MenuItem>)}
        </TextField>
        <InputText label="Código de empleado" name="dispatchEmployeeCode" placeholder="Ingresa tu código de empleado *" register={register("dispatchEmployeeCode", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmployeeCode(e.target.value),
        value: employeeCode,
        required: true
      })} type="password" disabled={isLoading} sx={{
        mb: 2
      }} />
        {errorMessage && <Alert severity="error" sx={{
        mt: 1
      }}>
            {errorMessage}
          </Alert>}
      </Box>;
  };
  return <ConfirmDialog open={open} cancelAction={onCancel} confirmAction={handleConfirm} title={isUnavailable ? "Despacho no disponible" : "Confirmar despacho de línea"} subtitle={productName} message="" cancelLabel="Cancelar" confirmLabel="Despachar" disabled={disabled} withEnter={true} withEscape={true} hideConfirm={warehousesStatus !== "ready"} contentRender={bodyContent()} />;
};
export default DispatchDialog;